import {CircularProgress} from "@mui/material";
import React from "react";
import Box from "@mui/material/Box";

const LoadingOverlay = ({sx={}}) => {
    return <Box sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
        ...sx
    }}>
        <CircularProgress color="info" size={60}/>
    </Box>
}

export default LoadingOverlay;